export default {
  goBackMyData: 'Мои данные',
  goBackProfile: 'Профиль',
  passport: {
    navText: 'Паспорт',
    title: 'Основной разворот паспорта',
    annotation: 'Загрузите основной разворот с местом и датой выдачи',
    successMessage: 'Фотография загружена'
  },
  registration: {
    navText: 'Прописка',
    title: 'Страница с пропиской',
    annotation: 'Загрузите страницу с пропиской из паспорта',
    successMessage: 'Фотография загружена'
  },
  snils: {
    navText: 'СНИЛС',
    title: 'СНИЛС',
    annotation: 'Загрузите основной разворот с местом и датой выдачи',
    successMessage: 'Фотография загружена'
  },
  inn: {
    navText: 'ИНН',
    title: 'ИНН',
    annotation: 'Загрузите свое свидетельство ИНН',
    successMessage: 'Фотография загружена'
  },
  next: 'Далее',
  sendToReview: 'Отправить на проверку',
  sendDocsSuccessMessage: 'Документы успешно отправлены на проверку 👍',
  sendDocsErrorMessage: 'При отправке документов произошла ошибка 🤔'
}
